export const useIsMobile = () => {
  return window.screen.width <= 900;
};
